import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ContentOwnerAutocompleteComponent} from './content-owner-autocomplete.component';
import {ContentOwner} from '../../domain/content-owner.model';

@Component({
    selector: 'ctv-content-owner-autocomplete-chips',
    template: `
    <div class="cs-publisher-autocomplete-chips-wrapper">
      <ctv-content-owner-autocomplete #cat
        (contentOwnerSelected)="onItemSelected($event)" [formFieldClass]="formFieldClass" [disabled]="disabled"
        [formFieldAppearance]="formFieldAppearance ? formFieldAppearance : ''"
        [placeholder]="placeholder"
        [floatLabel]="floatLabel">
      </ctv-content-owner-autocomplete>
      <mat-chip-listbox #chipList class="mt-n3"  [ngClass]="[stacked ? 'mat-chip-list-stacked' : '', items.length > 0 ? 'mb-4' : '']" [hidden]="items.length < 1">
        @for (item of items; track item) {
          <mat-basic-chip
            [removable]="!disabled"
            (removed)="remove(item)">
            {{item.name}}
            <button type="button" class="chip-remove-btn" matChipRemove aria-label="Remove"><i class="fas fa-times-circle text-danger" aria-hidden="true"></i></button>
          </mat-basic-chip>
        }
      </mat-chip-listbox>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentOwnerAutocompleteChipsComponent implements OnInit {

  @ViewChild(ContentOwnerAutocompleteComponent, {static: true}) cat: ContentOwnerAutocompleteComponent;

  @Input()
  public placeholder: string;

  @Input()
  public floatLabel: string;

  @Input()
  public stacked: false;

  @Input()
  public contentOwners: ContentOwner[];

  @Input()
  public formFieldClass: string;

  @Input()
  public formFieldAppearance: string;

  @Input()
  disabled: boolean;

  @Output()
  contentOwnerSelectionChange = new EventEmitter<string[]>();

  items: ContentOwner[] = [];

  constructor() {
  }

  ngOnInit(): void {
    if (this.contentOwners && this.contentOwners.length) {
      this.items = this.contentOwners;
    }
  }

  onItemSelected(contentOwner: ContentOwner) {
    if (contentOwner && this.items.findIndex(co => co.id === contentOwner.id) === -1) {
      this.items.push(contentOwner);
      this.contentOwnerSelectionChange.emit(this.items.map(co => co.id));
    }
    this.cat.resetInput();
    this.cat.updateFilteredCos(this.items);
  }

  remove(contentOwner: ContentOwner) {
    const index = this.items.findIndex(co => co.id === contentOwner.id);
    if (index > -1) {
      this.items.splice(index, 1);
      this.contentOwnerSelectionChange.emit(this.items.map(co => co.id));
      this.cat.updateFilteredCos(this.items);
    }
  }
}
